import { Component, Input, ViewEncapsulation, OnDestroy, OnChanges, AfterViewChecked, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FlattenPipe } from 'ngx-pipes';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Layout } from 'src/app/core/classes/layout';

import { Project } from 'src/app/core/classes/project';
import { IDynamicFormBlock } from 'src/app/core/models/dynamic-form-block.vm';
import { IDynamicTableColumn } from 'src/app/core/models/dynamic-table-column.vm';
import { ILayout } from 'src/app/core/models/layout.vm';
import { IProjectTier } from 'src/app/core/models/project-tier.vm';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { LoaderService } from 'src/app/core/services/loader.service';
import { ProjectService } from 'src/app/core/services/project.service';
import { Constants } from 'src/app/core/constants/constants';
import { DynamicFormComponent } from 'src/app/shared/dynamic-form/dynamic-form.component';
import {
  ParameterDetailsFormBlocks,
  ParameterDetailsTopFormBlocks,
  ParameterDetailsBottomFormBlocks,
  ParametersTableColumns,
  ReportDetailsFormBlocks,
  ReportOptionTableColumns,
  OptionDetailsFormBlocks,
  NewOptionDetailsFormBlocks,
  SeriesDetailsFormBlocks,
  TierDetailsFormBlocks,
  TierTableColumns,
  MetadataFormBlocks,
  ReportviewDetailsTableColumns,
} from './project-toolkit-layouts';
import { StoredProcedures } from 'src/app/core/models/stored-procedures';
import { selectStoredProcedures } from 'src/app/store/stored-procedures.selectors';
import moment from 'moment';

@Component({
  selector: 'app-project-toolkit',
  templateUrl: './project-toolkit.component.html',
  styleUrls: ['./project-toolkit.component.scss'],
  providers: [FlattenPipe],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectToolkitComponent implements OnChanges, OnDestroy, AfterViewChecked {
  @Input() public currentProject!: Project;
  @Input() public currentYear!: number;
  @Output() public id!: number;

  public currentQueryParams: any;

  public tierTableColumns: Array<IDynamicTableColumn> = TierTableColumns;
  public reportOptionsTableColumns: Array<IDynamicTableColumn> = ReportOptionTableColumns;
  public reportviewDetailsTableColumns: Array<IDynamicTableColumn> = ReportviewDetailsTableColumns;
  public parametersTableColumns: Array<IDynamicTableColumn> = ParametersTableColumns;

  public tierDetailsForm: Array<IDynamicFormBlock> = TierDetailsFormBlocks;
  public reportDetailsForm: Array<IDynamicFormBlock> = ReportDetailsFormBlocks;
  public seriesDetailsForm: Array<IDynamicFormBlock> = SeriesDetailsFormBlocks;
  public optionDetailsForm: Array<IDynamicFormBlock> = OptionDetailsFormBlocks;
  public newOptionDetailsForm: Array<IDynamicFormBlock> = NewOptionDetailsFormBlocks;
  public parameterDetailsForm: Array<IDynamicFormBlock> = ParameterDetailsFormBlocks;
  public parameterDetailsTopForm: Array<IDynamicFormBlock> = ParameterDetailsTopFormBlocks;
  public parameterDetailsBottomForm: Array<IDynamicFormBlock> = ParameterDetailsBottomFormBlocks;
  public metadataForm: Array<IDynamicFormBlock> = MetadataFormBlocks;

  @ViewChild('tierDetailsFormRef') public tierDetailsFormRef!: DynamicFormComponent;
  @ViewChild('reportDetailsFormRef') public reportDetailsFormRef!: DynamicFormComponent;
  @ViewChild('optionDetailsFormRef') public optionDetailsFormRef!: DynamicFormComponent;
  @ViewChild('parameterDetailsFormRef') public parameterDetailsFormRef!: DynamicFormComponent;
  @ViewChild('parameterDetailsTopFormRef') public parameterDetailsTopFormRef!: DynamicFormComponent;
  @ViewChild('parameterDetailsBottomFormRef') public parameterDetailsBottomFormRef!: DynamicFormComponent;

  public allReportSeries: any[] = [];
  public isLoadingReportSeries: boolean = false;
  public isSeriesPickerOpen: boolean = false;
  public seriesSearchText: string = '';
  public appliedSeriesSearch: string = '';
  private seriesSearchDebounce: any = null;
  public newSeriesName: string = '';
  public newSeriesDisplaySequence: number | null = 1;
  public isCreatingSeries: boolean = false;

  public storedProcedures!: StoredProcedures;

  public selectedTier: any = null;
  public selectedOption: any;
  public selectedParameter: any;

  public compareYears = (a: any, b: any): boolean => Number(a) === Number(b);

  public searchText: string = '';

  public tierLayout!: ILayout;
  public optionLayout!: ILayout;
  public parameterLayout!: ILayout;
  public reportViewLayout!: ILayout;

  public loadingError: string | null = null;
  private unsubscribe = new Subject();
  private trackedParameterTopForm: any = null;
  private parameterTopFormChangeSub: Subscription | null = null;

  public currentYearQuestions: any[] = [];
  public respondedQuestions: any[] = [];
  public isQuestionSelectorOpened = false;
  public searchPlaceholder: string = 'Search by question text or ID';
  public searchValue: string = '';
  public appliedSearchValue: string = '';

  public serviceItemId: Array<number> = []

  darkMode$: Observable<boolean>;
  public reportViewDetails: any[] = [];
  public isReportViewSliderOpen: boolean = false;
  public isReportViewDetailsLoading: boolean = false;
  private reportViewDetailsLoadedReportId: number | null = null;
  public isStoredProceduresLoading: boolean = false;
  public serviceItems: any = []
  public viewCode: string = '';
  public alert: any;
  public Constants: typeof Constants = Constants;
  public hasUnsavedViewTypesChanges: boolean = false;
  public tierReportYears: any[] = [];
  public isTierReportYearsLoading: boolean = false;
  private initialTierReportId: number | null = null;
  private initialMetadata: { genericSp: string | null; procName: string } = { genericSp: null, procName: '' };
  public isSavingMetadata: boolean = false;

  constructor(
    public loaderService: LoaderService,
    private flatten: FlattenPipe,
    private projectService: ProjectService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<{ darkMode: boolean }>,
    private storeTest: Store<{ testList: any }>
  ) {
    this.darkMode$ = store.select('darkMode');
  }

  ngOnChanges(): void {
    this.getServiceItems(this.currentProject.projectId)
    // Check for open registration
    this.route.queryParams.subscribe((params) => {
      this.currentQueryParams = params;
    });
    // Get tiers, if needed
    if (!this.currentProject.tiers) {
      this.getProjectTiers(this.currentProject.projectId, this.currentYear);
    }
  }

  ngOnDestroy(): void {
    this.parameterTopFormChangeSub?.unsubscribe();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  // The Parameter Type / Parameter Year / Mandatory row is rendered by a separate
  // <app-dynamic-form> (parameterDetailsTopFormRef) with its own FormGroup, so changes
  // there don't mark the Save Parameter button's form (parameterDetailsBottomFormRef) as
  // dirty. Re-subscribe to the top form's valueChanges whenever it's (re)built and mirror
  // any change into the bottom form's dirty state so the Save button enables correctly.
  ngAfterViewChecked(): void {
    const topForm = this.parameterDetailsTopFormRef?.form;
    if (topForm && topForm !== this.trackedParameterTopForm) {
      this.trackedParameterTopForm = topForm;
      this.parameterTopFormChangeSub?.unsubscribe();
      this.parameterTopFormChangeSub = topForm.valueChanges
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(() => this.markParameterFormDirty());
    }
  }

  public getProjectTiers(projectId: number, currentYear: number): void {
    this.projectService
      .getProjectTiers(projectId, currentYear)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (success) => {
          this.currentProject.tiers = this.currentProject.setTiers(
            success.data.tiers
          );
          // Open selected, if in params
          if (this.currentQueryParams.tier) {
            this.onTierClick(this.currentQueryParams.tier);
          }
        },
        (error) => {
          console.log('Error: ', error);
          this.loadingError = error.error.error.message;
        }
      );
  }

  public onTierClick = (primaryKey: string): void => {
    const selectedTier = this.currentProject.tiers.find(
      (tier) => tier.id == +primaryKey
    );
    if (!selectedTier) {
      return;
    }
    this.selectedTier = selectedTier;
    this.tierLayout = new Layout(
      this.selectedTier.name,
      [`Tier ID: ${this.selectedTier.id}`,],
      ''
    );
    this.router.navigate([], {
      queryParams: { tier: primaryKey },
      queryParamsHandling: 'merge',
    });
    if (this.selectedTier.chartId) {
      this.getTierReportYears(this.selectedTier.chartId, this.selectedTier.id);
    } else {
      this.tierReportYears = [];
    }
    this.initialTierReportId = this.selectedTier.reportId ?? null;
    // Get report details
    if (this.selectedTier.reportId) {
      this.getReportDetails(this.selectedTier); 
      this.getAllReports(this.selectedTier.projectId)
    }
  };

  private getAllReports(projectId: number) {
    this.projectService
      .getAllReports(projectId)
      .subscribe(
        (success) => {
          const allReports = success.data.responseList.map((item: any) => { return { id: item.reportId, name: "[" + item.reportId + "] " + item.reportName } });
          sessionStorage.setItem('projectReports',JSON.stringify(allReports))
        },
        (error) => {
          console.log('Error: ', error);
          this.loadingError = error.error.error.message;
        }
      );
  }

  private getReportDetails(selectedTier: IProjectTier, onLoaded?: () => void): void {
    this.projectService
      .getReportDetails(selectedTier.reportId, selectedTier.id)
      .subscribe(
        (success) => {
          this.loadingError = null;
          const yearForParams = (selectedTier.reportDetails as any)?.activeParameterYear ?? this.currentYear;
          selectedTier.reportDetails = this.currentProject.setReportDetails(
            success.data.reportDetails,
            yearForParams
          );
          this.selectedTier.reportDetails.softOptions = this.serviceItems
          this.selectedTier.reportDetails.serviceItemName = this.selectedTier.serviceItemName
          this.duplicateChartTypes()
          this.hasUnsavedViewTypesChanges = false;
          const rawGenericSp =
            (selectedTier.reportDetails as any).is_generic ?? selectedTier.reportDetails.genericSp;
          const genericSp =
            rawGenericSp === true || rawGenericSp === 1 || rawGenericSp === '1' || rawGenericSp === 'Y'
              ? 'Y'
              : rawGenericSp === false || rawGenericSp === 0 || rawGenericSp === '0' || rawGenericSp === 'N'
                ? 'N'
                : null;
          this.storedProcedures = {
            genericSp: genericSp,
            storedProcedure: {
              objectId: 0,
              objectName: selectedTier.reportDetails.procName,
            },
            allStoredProcedures: [],
          };
          this.initialMetadata = {
            genericSp: genericSp,
            procName: selectedTier.reportDetails.procName || '',
          };
          this.getStoredProcedures();

          // Open selected, if in params
          if (this.currentQueryParams.option) {
            this.onOptionClick(this.currentQueryParams.option);
          }

          this.syncActiveYear();
          if (onLoaded) { onLoaded(); }
        },
        (error) => {
          console.log('Error: ', error);
          const message = error.error?.error?.message || '';
          const isMissingTierReport = /not found/i.test(message) && /tier id/i.test(message);
          this.loadingError = isMissingTierReport
            ? `${message} Are there any Tier Years defined?`
            : message;
        }
      );
  }

  public closeTierSlider = (): void => {
    this.selectedTier = null;
    this.isReportViewSliderOpen = false;
    this.reportViewDetails = [];
    this.reportViewDetailsLoadedReportId = null;
    this.tierReportYears = [];
    this.router.navigate([], {
      queryParams: { tier: null },
      queryParamsHandling: 'merge',
    });
  };

  public onOptionClick = (primaryKey: string): void => {
    const found = this.selectedTier.reportDetails.options.find(
      (opt: any) => opt.optionId == +primaryKey
    );
    if (!found) { return; }
    this.selectedOption = found;
    this.selectedOption.formatModifier =  this.selectedOption.formatModifier ? this.selectedOption.formatModifier : '';
    this.optionLayout = new Layout(
      this.selectedOption.optionName,
      [`Option ID: ${this.selectedOption.optionId}`],
      ''
    );
    this.router.navigate([], {
      queryParams: { option: primaryKey },
      queryParamsHandling: 'merge',
    });
    // Open selected, if in params
    if (this.currentQueryParams.param) {
      this.onParameterClick(this.currentQueryParams.param);
    }
  };

  public closeOptionSlider = (): void => {
    this.selectedOption = null;
    this.router.navigate([], {
      queryParams: { option: null },
      queryParamsHandling: 'merge',
    });
  };

  public openNewOption(): void {
    if (!this.selectedTier || !this.selectedTier.reportDetails) { return; }
    const existing = this.selectedTier.reportDetails.options || [];
    let nextId = 0;
    if (existing.length > 0) {
      nextId = existing.reduce(
        (max: number, opt: any) => (Number(opt.optionId) > max ? Number(opt.optionId) : max),
        -1
      ) + 1;
    }
    this.selectedOption = {
      isNew: true,
      optionId: nextId,
      optionName: '',
      displaySequence: existing.length + 1,
      titleOptionName: '',
      formatModifier: '',
      optionType: '',
      includeNulls: 'N',
      series: [],
    };
    this.optionLayout = new Layout('New Report Option', ['Add a new option'], '');
  }

  public onOptionSave(event: any): void {
    if (!event || !this.selectedTier || !this.selectedTier.reportId || !this.selectedOption) {
      return;
    }
    if (event.action !== 'saveOption' && event.action !== 'addOption') {
      return;
    }
    const row = event.row || {};
    const reportId = this.selectedTier.reportId;
    const isNew = event.action === 'addOption' || this.selectedOption.isNew;

    if (isNew) {
      const denominatorId = Number(row.optionId);
      const denominatorName = (row.optionName || '').toString().trim();
      const displaySequence = Number(row.displaySequence);
      const idMissing = row.optionId === undefined || row.optionId === null || row.optionId === '' || isNaN(denominatorId);
      if (idMissing || !denominatorName || isNaN(displaySequence)) {
        this.alert = {
          message: 'Option ID, Name and Display Sequence are required.',
          alertClass: 'danger',
          fadeOut: true,
        };
        return;
      }
      const body: any = {
        denominatorId,
        reportId,
        denominatorName,
        displaySequence,
      };
      if (row.titleOptionName) { body.titleOptionName = row.titleOptionName; }
      if (row.optionType) { body.type = row.optionType; }
      if (row.formatModifier) { body.formatModifier = row.formatModifier; }
      if (row.includeNulls) { body.includeNulls = row.includeNulls; }
      const savedNewOption = this.selectedOption;
      this.projectService.addReportDenominator(reportId, body).subscribe(
        () => {
          this.alert = { message: 'Option added.', alertClass: 'success', fadeOut: true };
          const createdId = denominatorId;
          this.getReportDetails(this.selectedTier, () => {
            const fresh = (this.selectedTier?.reportDetails?.options || []).find((opt: any) => Number(opt.optionId) === Number(createdId));
            if (fresh) {
              this.selectedOption = fresh;
              this.selectedOption.formatModifier = this.selectedOption.formatModifier ? this.selectedOption.formatModifier : '';
              this.optionLayout = new Layout(
                this.selectedOption.optionName,
                [`Option ID: ${this.selectedOption.optionId}`],
                ''
              );
            } else {
              savedNewOption.isNew = false;
              this.selectedOption = savedNewOption;
            }
            this.optionDetailsFormRef?.form?.markAsPristine();
            this.optionDetailsFormRef?.form?.markAsUntouched();
          });
          if (this.selectedTier.chartId) {
            this.getTierReportYears(this.selectedTier.chartId, this.selectedTier.id);
          }
        },
        (error) => {
          console.log('Error: ', error);
          this.alert = {
            message: `<strong>Add Failed</strong><br/>${error.error?.error?.message || ''}`,
            alertClass: 'danger',
            fadeOut: true,
          };
        }
      );
    } else {
      const body: any = {
        denominatorId: Number(this.selectedOption.optionId),
        reportId,
      };
      if (row.optionName !== undefined && row.optionName !== null) { body.denominatorName = row.optionName; }
      if (row.displaySequence !== undefined && row.displaySequence !== null && !isNaN(Number(row.displaySequence))) { body.displaySequence = Number(row.displaySequence); }
      if (row.titleOptionName !== undefined && row.titleOptionName !== null) { body.titleOptionName = row.titleOptionName; }
      if (row.optionType !== undefined && row.optionType !== null && row.optionType !== '') { body.type = row.optionType; }
      if (row.formatModifier !== undefined && row.formatModifier !== null && row.formatModifier !== '') { body.formatModifier = row.formatModifier; }
      if (row.includeNulls !== undefined && row.includeNulls !== null && row.includeNulls !== '') { body.includeNulls = row.includeNulls; }
      this.projectService.updateReportDenominator(reportId, body).subscribe(
        () => {
          Object.assign(this.selectedOption, row);
          this.optionDetailsFormRef?.form?.markAsPristine();
          this.optionDetailsFormRef?.form?.markAsUntouched();
          this.alert = { message: 'Option saved.', alertClass: 'success', fadeOut: true };
          this.refreshTierSlider();
        },
        (error) => {
          console.log('Error: ', error);
          this.alert = {
            message: `<strong>Save Failed</strong><br/>${error.error?.error?.message || ''}`,
            alertClass: 'danger',
            fadeOut: true,
          };
        }
      );
    }
  }

  public onOptionDelete(): void {
    if (!this.selectedTier || !this.selectedTier.reportId || !this.selectedOption) { return; }
    if (this.selectedOption.isNew) {
      this.closeOptionSlider();
      return;
    }
    const denominatorId = Number(this.selectedOption.optionId);
    if (denominatorId === 0) {
      this.alert = {
        message: 'Option 0 is the default option and cannot be deleted.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }
    const hasParameters = (this.selectedOption.series || []).some((s: any) => s.parameters && s.parameters.length > 0);
    if (hasParameters) {
      this.alert = {
        message: 'This option has parameters and cannot be deleted. Remove all parameters first.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }
    if (!confirm(`Delete option "${this.selectedOption.optionName}" (ID ${denominatorId})?`)) {
      return;
    }
    this.projectService.deleteReportDenominator(this.selectedTier.reportId, denominatorId).subscribe(
      () => {
        this.alert = { message: 'Option deleted.', alertClass: 'success', fadeOut: true };
        this.closeOptionSlider();
        this.refreshTierSlider();
      },
      (error) => {
        console.log('Error: ', error);
        this.alert = {
          message: `<strong>Delete Failed</strong><br/>${error.error?.error?.message || ''}`,
          alertClass: 'danger',
          fadeOut: true,
        };
      }
    );
  }

  public onParameterClick = (primaryKey: string): void => {
    // TODO: Look for a faster way to do this
    // Change dynamic-table to accept whole object?
    let allParameters = this.flatten.transform(
      this.selectedOption.series.map((series: any) =>
        series.parameters.map((param: any) => {
          return { seriesId: series.seriesId, paramId: param.parameterId };
        })
      )
    );
    let selectedParameter = allParameters.find(
      (param: any) => param.paramId == +primaryKey
    );
    let selectedSeries = this.selectedOption.series.find(
      (series: any) => series.seriesId == selectedParameter.seriesId
    );
    // end

    this.selectedParameter = selectedSeries.parameters.find(
      (param: any) => param.parameterId == selectedParameter.paramId
    );
    this.selectedParameter.seriesId = selectedSeries.seriesId;
    this.selectedParameter.seriesName = selectedSeries.seriesName;
    if (this.selectedParameter.parameterYear === undefined || this.selectedParameter.parameterYear === null) {
      this.selectedParameter.parameterYear = this.selectedTier?.reportDetails?.activeParameterYear ?? this.currentYear;
    }
    this.parameterLayout = new Layout(
      //this.selectedParameter.questionText,
      selectedSeries.seriesName,
      [`Parameter ID: ${this.selectedParameter.parameterId}`],
      ''
    );
    this.router.navigate([], {
      queryParams: { param: primaryKey },
      queryParamsHandling: 'merge',
    });
  };

  public closeParameterSlider = (): void => {
    this.isQuestionSelectorOpened = false;
    this.selectedParameter = null;
    this.isSeriesPickerOpen = false;
    this.seriesSearchText = '';
    this.appliedSeriesSearch = '';
    if (this.seriesSearchDebounce) { clearTimeout(this.seriesSearchDebounce); this.seriesSearchDebounce = null; }
    this.newSeriesName = '';
    this.newSeriesDisplaySequence = 1;
    this.router.navigate([], {
      queryParams: { param: null },
      queryParamsHandling: 'merge',
    });
  };

  public get combinedParameterYears(): number[] {
    const paramYears: number[] = this.selectedTier?.reportDetails?.availableParameterYears || [];
    const tierYears: number[] = (this.tierReportYears || [])
      .filter((y: any) => !y.isNew)
      .map((y: any) => Number(y.reportYear))
      .filter((y: number) => !isNaN(y));
    return Array.from(new Set([...paramYears, ...tierYears])).sort((a, b) => b - a);
  }

  private syncActiveYear(): void {
    if (!this.selectedTier?.reportDetails) { return; }
    const combined = this.combinedParameterYears;
    if (!combined.length) { return; }
    const current = this.selectedTier.reportDetails.activeParameterYear;
    if (current == null || !combined.some(y => this.compareYears(y, current))) {
      this.selectedTier.reportDetails.activeParameterYear = combined[0];
    }
  }

  public onParameterYearChange(year: number): void {
    const reportDetails = this.selectedTier?.reportDetails;
    if (!reportDetails) { return; }

    const parameterYearData = reportDetails.parameterYearData || {};
    const yearParams = parameterYearData[year]?.options || null;
    const options: any[] = reportDetails.options || [];

    const newOptions = options.map((opt: any) => {
      const optParams = yearParams ? yearParams[opt.optionId] : null;
      if (optParams?.series) {
        return { ...opt, seriesCount: Object.keys(optParams.series).length, series: Object.values(optParams.series) };
      }
      return { ...opt, seriesCount: 0, series: [] };
    });

    reportDetails.options = newOptions;
    reportDetails.activeParameterYear = year;

    if (this.selectedOption) {
      const optionId = this.selectedOption.optionId;
      this.selectedOption = newOptions.find((opt: any) => Number(opt.optionId) === Number(optionId)) || this.selectedOption;
    }
  }

  public openNewParameter(seriesId?: number): void {
    if (!this.selectedTier || !this.selectedOption) { return; }
    const defaultSeriesId = seriesId && seriesId > 0 ? seriesId : 1;
    const matchingSeries = (this.selectedOption.series || []).find((s: any) => s.seriesId === defaultSeriesId);
    this.selectedParameter = {
      isNew: true,
      parameterId: null,
      seriesId: defaultSeriesId,
      seriesName: matchingSeries?.seriesName || '',
      parameterType: 'N',
      parameterYear: this.selectedTier?.reportDetails?.activeParameterYear ?? this.currentYear,
      isMandatory: 'Y',
      questionId: null,
      questionPart: null,
      constantValue: null,
      parameterDefinition: '',
    };
    this.parameterLayout = new Layout('New Parameter', ['Add a new parameter'], '');
  }

  public onParameterSave(event: any): void {
    if (!event || event.action !== 'saveParameter' || !this.selectedTier || !this.selectedTier.reportId || !this.selectedParameter) {
      return;
    }
    const bottomRow = event.row || {};
    const topRow = this.parameterDetailsTopFormRef?.form?.getRawValue() || {};
    const row = { ...topRow, ...bottomRow };
    const reportId = this.selectedTier.reportId;
    const isNew = this.selectedParameter.isNew;
    const seriesId = Number(this.selectedParameter.seriesId);
    const optionId = Number(this.selectedOption?.optionId);
    const hasServiceItems = Array.isArray(this.serviceItemId) && this.serviceItemId.length > 0;
    const serviceItemId = hasServiceItems
      ? Number(this.selectedTier.serviceItemId ?? this.selectedTier.reportDetails?.serviceItemId)
      : 0;
    const parameterYear = Number(row.parameterYear);
    const parameterType = row.parameterType;
    const isMandatory = row.isMandatory;

    const hasValue = (v: any) => v !== undefined && v !== null && v !== '';
    const hasQuestionId = hasValue(row.questionId);
    const hasQuestionPart = hasValue(row.questionPart);
    const hasConstant = hasValue(row.constantValue);
    if (!(hasConstant || (hasQuestionId && hasQuestionPart))) {
      this.alert = {
        message: 'Provide either Question ID and Question Part, or a Constant Value.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }
    if (hasConstant && (hasQuestionId || hasQuestionPart)) {
      this.alert = {
        message: 'Provide either Question ID and Question Part, or a Constant Value \u2014 not both.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }

    if (isNew) {
      if (!seriesId || isNaN(optionId) || isNaN(serviceItemId) || isNaN(parameterYear) || !parameterType || !isMandatory) {
        this.alert = {
          message: 'Series, Option, Service Item, Parameter Year, Type and Mandatory are required.',
          alertClass: 'danger',
          fadeOut: true,
        };
        return;
      }
      const body: any = {
        reportId,
        optionId,
        seriesId,
        serviceItemId,
        parameterYear,
        parameterType,
        isMandatory,
      };
      if (row.questionId !== undefined && row.questionId !== null && row.questionId !== '') { body.questionId = Number(row.questionId); }
      if (row.questionPart !== undefined && row.questionPart !== null && row.questionPart !== '') { body.questionPart = Number(row.questionPart); }
      if (row.constantValue !== undefined && row.constantValue !== null && row.constantValue !== '') { body.constantValue = Number(row.constantValue); }
      if (row.parameterDefinition) { body.parameterDefinition = row.parameterDefinition; }
      this.projectService.addReportParameter(reportId, body).subscribe(
        () => {
          this.alert = { message: 'Parameter added.', alertClass: 'success', fadeOut: true };
          this.closeParameterSlider();
          this.refreshTierSlider();
        },
        (error) => {
          console.log('Error: ', error);
          this.alert = {
            message: `<strong>Add Failed</strong><br/>${error.error?.error?.message || ''}`,
            alertClass: 'danger',
            fadeOut: true,
          };
        }
      );
    } else {
      const parameterId = Number(this.selectedParameter.parameterId);
      const body: any = {};
      if (!isNaN(optionId)) { body.optionId = optionId; }
      if (seriesId) { body.seriesId = seriesId; }
      if (!isNaN(serviceItemId)) { body.serviceItemId = serviceItemId; }
      if (!isNaN(parameterYear)) { body.parameterYear = parameterYear; }
      if (parameterType) { body.parameterType = parameterType; }
      if (isMandatory) { body.isMandatory = isMandatory; }
      body.questionId = (row.questionId !== undefined && row.questionId !== null && row.questionId !== '') ? Number(row.questionId) : null;
      body.questionPart = (row.questionPart !== undefined && row.questionPart !== null && row.questionPart !== '') ? Number(row.questionPart) : null;
      body.constantValue = (row.constantValue !== undefined && row.constantValue !== null && row.constantValue !== '') ? Number(row.constantValue) : null;
      body.parameterDefinition = (row.parameterDefinition !== undefined && row.parameterDefinition !== null && row.parameterDefinition !== '') ? row.parameterDefinition : null;
      this.projectService.updateReportParameter(parameterId, body).subscribe(
        () => {
          Object.assign(this.selectedParameter, row);
          this.parameterDetailsFormRef?.form?.markAsPristine();
          this.parameterDetailsFormRef?.form?.markAsUntouched();
          this.parameterDetailsTopFormRef?.form?.markAsPristine();
          this.parameterDetailsTopFormRef?.form?.markAsUntouched();
          this.parameterDetailsBottomFormRef?.form?.markAsPristine();
          this.parameterDetailsBottomFormRef?.form?.markAsUntouched();
          this.alert = { message: 'Parameter saved.', alertClass: 'success', fadeOut: true };
          this.refreshTierSlider();
        },
        (error) => {
          console.log('Error: ', error);
          this.alert = {
            message: `<strong>Save Failed</strong><br/>${error.error?.error?.message || ''}`,
            alertClass: 'danger',
            fadeOut: true,
          };
        }
      );
    }
  }

  public onParameterDelete(): void {
    if (!this.selectedTier || !this.selectedTier.reportId || !this.selectedParameter) { return; }
    if (this.selectedParameter.isNew) {
      this.closeParameterSlider();
      return;
    }
    const parameterId = Number(this.selectedParameter.parameterId);
    if (!parameterId) { return; }
    if (!confirm(`Delete parameter (ID ${parameterId})?`)) { return; }
    this.projectService.deleteReportParameter(parameterId).subscribe(
      () => {
        this.alert = { message: 'Parameter deleted.', alertClass: 'success', fadeOut: true };
        this.closeParameterSlider();
        this.refreshTierSlider();
      },
      (error) => {
        console.log('Error: ', error);
        this.alert = {
          message: `<strong>Delete Failed</strong><br/>${error.error?.error?.message || ''}`,
          alertClass: 'danger',
          fadeOut: true,
        };
      }
    );
  }

  public toggleSeriesPicker(): void {
    this.isSeriesPickerOpen = !this.isSeriesPickerOpen;
    if (this.isSeriesPickerOpen && this.allReportSeries.length === 0) {
      this.loadAllReportSeries();
    }
  }

  private loadAllReportSeries(): void {
    this.isLoadingReportSeries = true;
    this.projectService.getAllReportSeries().subscribe(
      (success: any) => {
        const list = this.extractSeriesArray(success);
        this.allReportSeries = (list || []).map((s: any) => this.normaliseSeries(s));
        this.isLoadingReportSeries = false;
      },
      (error) => {
        this.isLoadingReportSeries = false;
        console.log('Error: ', error);
        this.alert = {
          message: `<strong>Failed to load series</strong><br/>${error.error?.error?.message || ''}`,
          alertClass: 'danger',
          fadeOut: true,
        };
      }
    );
  }

  private extractSeriesArray(response: any): any[] {
    if (!response) { return []; }
    if (Array.isArray(response)) { return response; }
    const candidates = [
      response.reportSeries,
      response.series,
      response.data,
      response.data?.reportSeries,
      response.data?.series,
      response.data?.data,
      response.results,
      response.data?.results,
    ];
    for (const c of candidates) {
      if (Array.isArray(c)) { return c; }
    }
    // Last resort: walk one level deeper
    if (response.data && typeof response.data === 'object') {
      for (const key of Object.keys(response.data)) {
        if (Array.isArray((response.data as any)[key])) { return (response.data as any)[key]; }
      }
    }
    for (const key of Object.keys(response)) {
      if (Array.isArray((response as any)[key])) { return (response as any)[key]; }
    }
    return [];
  }

  private normaliseSeries(s: any): any {
    if (!s) { return s; }
    return {
      ...s,
      seriesId: s.seriesId ?? s.series_id ?? s.id,
      seriesName: s.seriesName ?? s.series_name ?? s.name,
      displaySequence: s.displaySequence ?? s.display_sequence ?? s.sequence,
    };
  }

  public get filteredReportSeries(): any[] {
    const term = (this.appliedSeriesSearch || '').toString().trim().toLowerCase();
    if (!term) { return []; }
    return this.allReportSeries.filter((s: any) => {
      const name = (s.seriesName || '').toString().toLowerCase();
      const id = (s.seriesId ?? '').toString().toLowerCase();
      return name.indexOf(term) !== -1 || id.indexOf(term) !== -1;
    });
  }

  public onSeriesSearchChange(value: string): void {
    this.seriesSearchText = value;
    if (this.seriesSearchDebounce) { clearTimeout(this.seriesSearchDebounce); }
    this.seriesSearchDebounce = setTimeout(() => {
      this.appliedSeriesSearch = this.seriesSearchText;
      this.seriesSearchDebounce = null;
    }, 300);
  }

  public applySeriesSearchNow(): void {
    if (this.seriesSearchDebounce) { clearTimeout(this.seriesSearchDebounce); this.seriesSearchDebounce = null; }
    this.appliedSeriesSearch = this.seriesSearchText;
  }

  public selectSeriesForParameter(series: any): void {
    if (!this.selectedParameter || !series) { return; }
    this.selectedParameter.seriesId = Number(series.seriesId);
    this.selectedParameter.seriesName = series.seriesName;
    this.markParameterFormDirty();
    this.isSeriesPickerOpen = false;
    this.seriesSearchText = '';
    this.appliedSeriesSearch = '';
    if (this.seriesSearchDebounce) { clearTimeout(this.seriesSearchDebounce); this.seriesSearchDebounce = null; }
  }

  public createNewSeries(): void {
    const name = (this.newSeriesName || '').toString().trim();
    if (!name) {
      this.alert = { message: 'Series Name is required.', alertClass: 'danger', fadeOut: true };
      return;
    }
    const body: any = { seriesName: name };
    if (this.newSeriesDisplaySequence !== null && this.newSeriesDisplaySequence !== undefined && !isNaN(Number(this.newSeriesDisplaySequence))) {
      body.displaySequence = Number(this.newSeriesDisplaySequence);
    }
    this.isCreatingSeries = true;
    this.projectService.addReportSeries(body).subscribe(
      (response: any) => {
        this.isCreatingSeries = false;
        if (!response?.success) {
          this.alert = {
            message: `<strong>Create Series Failed</strong><br/>${response?.error?.message || ''}`,
            alertClass: 'danger',
            fadeOut: true,
          };
          return;
        }
        const newSeries: any = {
          seriesId: Number(response.data.newSeriesId),
          seriesName: name,
        };
        this.allReportSeries = [newSeries, ...this.allReportSeries];
        this.selectSeriesForParameter(newSeries);
        this.newSeriesName = '';
        this.newSeriesDisplaySequence = 1;
        this.alert = { message: 'Series created.', alertClass: 'success', fadeOut: true };
      },
      (error) => {
        this.isCreatingSeries = false;
        console.log('Error: ', error);
        this.alert = {
          message: `<strong>Create Series Failed</strong><br/>${error.error?.error?.message || ''}`,
          alertClass: 'danger',
          fadeOut: true,
        };
      }
    );
  }

  private markParameterFormDirty(): void {
    const bottom = this.parameterDetailsBottomFormRef?.form;
    if (bottom) {
      const anyCtrl = bottom.get('questionId') || bottom.get('parameterDefinition');
      if (anyCtrl) {
        anyCtrl.markAsDirty();
        anyCtrl.markAsTouched();
      }
      bottom.markAsDirty();
    }
    const top = this.parameterDetailsTopFormRef?.form;
    if (top) {
      const ctrl = top.get('parameterYear');
      if (ctrl) {
        ctrl.markAsDirty();
        ctrl.markAsTouched();
      }
      top.markAsDirty();
    }
    this.parameterDetailsFormRef?.form?.markAsDirty();
  }

  private getStoredProcedures() {
    this.isStoredProceduresLoading = true;
    this.store.select(selectStoredProcedures).subscribe(
      (data) => {
        this.storedProcedures.allStoredProcedures = Array.isArray(data) ? data : [];
        const selectedStoredProcedure = this.storedProcedures.allStoredProcedures.find(
          (sP) => sP.objectName === this.storedProcedures.storedProcedure.objectName
        );

        if (selectedStoredProcedure) {
          this.storedProcedures.storedProcedure.objectName = selectedStoredProcedure.objectName;
          this.storedProcedures.storedProcedure.objectId = selectedStoredProcedure.objectId;
        }

        this.isStoredProceduresLoading = this.storedProcedures.allStoredProcedures.length === 0;
        
      },
      (error) => {
        this.isStoredProceduresLoading = false;
        console.log('Error: ', error);
        this.loadingError = error.error.error.message;
      }
    );
  }

  public getReportViewDetails(reportId: number, currentYear: number): void {
    this.isReportViewDetailsLoading = true;
    this.projectService.getReportViewDetails(reportId, currentYear).subscribe(
      (success) => {
        success.data.reportViews.forEach((value: any) => {
          value["timeAccessed"] = moment(value.timeAccessed).format('LLL')
        })
        this.reportViewDetails = success.data.reportViews
        this.reportViewDetailsLoadedReportId = reportId;
        this.isReportViewDetailsLoading = false;
      },
      (error) => {
        this.isReportViewDetailsLoading = false;
        console.log('Error: ', error);
        this.loadingError = error.error?.error?.message || 'Failed to load Report View Details.';
      }
    )
  }

  public openReportViewDetailsSlider(): void {
    if (!this.selectedTier || !this.selectedTier.reportId) {
      return;
    }

    this.reportViewLayout = new Layout(
      'Report View Details',
      [`Chart ID: ${this.selectedTier.chartId}`, `Report ID: ${this.selectedTier.reportId}`],
      ''
    );

    this.isReportViewSliderOpen = true;

    // Lazy load once per selected report.
    if (this.reportViewDetailsLoadedReportId !== this.selectedTier.reportId) {
      this.getReportViewDetails(this.selectedTier.reportId, this.currentYear);
    }
  }

  public closeReportViewSlider = (): void => {
    this.isReportViewSliderOpen = false;
  };

  public getServiceItems(projectId: number){
    this.projectService.getProjectServiceItems(projectId, this.currentYear).subscribe(
      (success) => {
        const visible = success.data.serviceItemList.filter((a: any) => !a.isVisibleInYear || a.isVisibleInYear.code === 'Y');
        visible.forEach((a: any) => this.serviceItems.push(a.serviceItemName));
        visible.forEach((a: any) => this.serviceItemId.push(a.serviceItemId));
        const dropdownOptions = [
          { id: 0, name: '0 - All Services' },
          ...visible.map((a: any) => ({ id: a.serviceItemId, name: a.serviceItemName })),
        ];
        sessionStorage.setItem(`services_${this.currentYear}`, JSON.stringify(dropdownOptions));
      }
    )
  }

  public duplicateChartTypes(){
    this.selectedTier.reportDetails.reportTypes.forEach((type: any) => {
      type.chartTypeDupe = type.chartType
    })
  }

  public idReceived(event: any){
    this.selectedTier!.reportDetails.reportTypes.filter((value: any) => {
      if(value.displaySequence == event.count ){
        value.chartTypeDupe = event.name
        value.chartType = event.name
      }
    })
    this.selectedTier!.reportDetails = Object.assign({}, this.selectedTier!.reportDetails)
 }

  // // ///////////////////////////////////////////// QUESTION SELECTOR LOGIC //////////////////////////////////////////////////////////////////////////////////////

  private getProjectQuestions(projectId: number, currentYear: number, serviceItemId: any): void {
    this.projectService.getProjectQuestions(projectId, currentYear, serviceItemId).subscribe(
      (success) => {
        this.currentYearQuestions = (success && success.data && success.data.projectQuestions) || [];
        // filter out not responded questions
        this.respondedQuestions = this.currentYearQuestions.filter(
          (q) => q.questionType !== 'NR'
        );
        this.respondedQuestions.forEach(q=>q['questionDetails']= [])
      },
      (error) => {
        console.log('Error: ', error);
        this.loadingError = error.error?.error?.message || 'Failed to load questions';
      }
    );
  }

  public updateStoredProcedure(objectName: string, objectId: number) {
    this.storedProcedures.storedProcedure = { objectId, objectName };
  }

  public get hasUnsavedMetadataChanges(): boolean {
    if (!this.storedProcedures) {
      return false;
    }
    const currentGenericSp = this.storedProcedures.genericSp ?? null;
    const currentProcName = this.storedProcedures.storedProcedure?.objectName ?? '';
    return (
      currentGenericSp !== this.initialMetadata.genericSp ||
      currentProcName !== this.initialMetadata.procName
    );
  }

  public saveMetadata(): void {
    if (!this.selectedTier || !this.selectedTier.reportId || !this.storedProcedures) {
      return;
    }
    const genericSp = this.storedProcedures.genericSp;
    const procName = this.storedProcedures.storedProcedure?.objectName || '';
    this.isSavingMetadata = true;
    this.projectService.updateReportStoredProcedure(this.selectedTier.reportId, genericSp, procName).subscribe(
      () => {
        this.isSavingMetadata = false;
        this.initialMetadata = { genericSp, procName };
        if (this.selectedTier?.reportDetails) {
          this.selectedTier.reportDetails.genericSp = genericSp;
          this.selectedTier.reportDetails.procName = procName;
        }
        this.alert = { message: 'Stored procedure settings saved.', alertClass: 'success', fadeOut: true };
      },
      (error) => {
        this.isSavingMetadata = false;
        console.log('Error: ', error);
        this.loadingError = error.error?.error?.message || 'Failed to save stored procedure settings.';
      }
    );
  }

  public onTierDetailsSave(event: any): void {
    if (!event || event.action !== 'saveTier' || !this.selectedTier) {
      return;
    }
    const row = event.row || {};
    const newReportId = row.reportId !== undefined && row.reportId !== null && row.reportId !== '' ? Number(row.reportId) : null;
    const reportIdChanged = newReportId !== null && newReportId !== this.initialTierReportId;
    const existingYears = this.tierReportYears.filter((y) => !y.isNew);
    if (reportIdChanged && existingYears.length > 0) {
      const proceed = confirm('Changing Report ID will delete all Tier Years for this tier. Continue?');
      if (!proceed) {
        return;
      }
    }
    const allowed = ['parentId', 'projectId', 'tierName', 'serviceItemId', 'reportId', 'isVisible', 'displaySequence', 'chartDefaultYear', 'submissionLevel', 'optionsDropdownTitle'];
    const mapped: any = {
      ...row,
      tierName: row.name,
      chartDefaultYear: row.defaultYear,
    };
    delete mapped.name;
    delete mapped.defaultYear;
    const body: any = {};
    Object.keys(mapped).forEach((key) => {
      if (allowed.indexOf(key) !== -1 && mapped[key] !== undefined && mapped[key] !== null) {
        body[key] = mapped[key];
      }
    });
    this.projectService.updateTierDetails(this.selectedTier.id, body).subscribe(
      () => {
        Object.assign(this.selectedTier, row);
        this.tierDetailsFormRef?.form?.markAsPristine();
        this.tierDetailsFormRef?.form?.markAsUntouched();
        if (reportIdChanged && existingYears.length > 0) {
          this.cascadeDeleteTierYears(existingYears);
        }
        if (reportIdChanged && newReportId !== null) {
          this.selectedTier.chartId = newReportId;
          this.selectedTier.reportDetails = null;
          this.storedProcedures = undefined as any;
          this.initialMetadata = { genericSp: null, procName: '' };
        }
        this.initialTierReportId = newReportId;
        this.refreshTierSlider();
        this.alert = { message: 'Tier details saved.', alertClass: 'success', fadeOut: true };
      },
      (error) => {
        console.log('Error: ', error);
        this.alert = {
          message: `<strong>Save Failed</strong><br/>${error.error?.error?.message || ''}`,
          alertClass: 'danger',
          fadeOut: true,
        };
      }
    );
  }

  private cascadeDeleteTierYears(years: any[]): void {
    if (!this.selectedTier || years.length === 0) { return; }
    const tierId = this.selectedTier.id;
    let pending = years.length;
    years.forEach((row) => {
      this.projectService.deleteTierReportYear(row.reportId, tierId, row.reportYear).subscribe(
        () => {
          pending -= 1;
          if (pending === 0) {
            this.tierReportYears = this.tierReportYears.filter((y) => y.isNew);
          }
        },
        (error) => {
          pending -= 1;
          console.log('Error: ', error);
          if (pending === 0) {
            if (this.selectedTier?.chartId) {
              this.getTierReportYears(this.selectedTier.chartId, this.selectedTier.id);
            }
          }
        }
      );
    });
  }

  public onReportDetailsSave(event: any): void {
    if (!event || event.action !== 'saveReport' || !this.selectedTier || !this.selectedTier.reportId) {
      return;
    }
    const row = event.row || {};
    const allowed = ['reportName', 'axisLabel', 'procName', 'hasTable', 'chartTableDecPlaces', 'decPlaces', 'formatModifier', 'showChartTable', 'maxValue', 'peerGroupListId', 'genericSp', 'showNulls', 'hideCodes', 'hideControlLines', 'selectSubmissions', 'colourProfile', 'showTotalResponses', 'sortOrder', 'minValue', 'maxXvalue', 'minXvalue', 'showR'];
    const body: any = {};
    Object.keys(row).forEach((key) => {
      if (allowed.indexOf(key) !== -1 && row[key] !== undefined && row[key] !== null) {
        body[key] = row[key];
      }
    });
    this.projectService.updateReportDetails(this.selectedTier.reportId, body).subscribe(
      () => {
        if (this.selectedTier.reportDetails) {
          Object.assign(this.selectedTier.reportDetails, row);
        }
        this.reportDetailsFormRef?.form?.markAsPristine();
        this.reportDetailsFormRef?.form?.markAsUntouched();
        this.refreshTierSlider();
        this.alert = { message: 'Report details saved.', alertClass: 'success', fadeOut: true };
      },
      (error) => {
        console.log('Error: ', error);
        this.alert = {
          message: `<strong>Save Failed</strong><br/>${error.error?.error?.message || ''}`,
          alertClass: 'danger',
          fadeOut: true,
        };
      }
    );
  }

  // ///////////////////////////////////////////// TIER YEARS MANAGEMENT //////////////////////////////////////////////////////////////////////////////////////

  private refreshTierSlider(): void {
    if (!this.selectedTier) { return; }
    if (this.selectedTier.reportId) {
      const currentOptionId = this.selectedOption?.optionId;
      this.getReportDetails(this.selectedTier, () => {
        if (currentOptionId != null) {
          const fresh = (this.selectedTier?.reportDetails?.options || []).find(
            (opt: any) => Number(opt.optionId) === Number(currentOptionId)
          );
          if (fresh) {
            this.selectedOption = fresh;
          }
        }
      });
    }
    if (this.selectedTier.chartId) {
      this.getTierReportYears(this.selectedTier.chartId, this.selectedTier.id);
    }
  }

  private getTierReportYears(chartId: number, tierId: number): void {
    this.isTierReportYearsLoading = true;
    this.projectService.getTierReportYears(chartId, tierId).subscribe(
      (success: any) => {
        const data = success?.data || {};
        const list = data.reportYears || data.tierReportYears || data.years || (Array.isArray(data) ? data : []);
        const mapped = Array.isArray(list) ? list.map((r: any) => ({ ...r, isNew: false })) : [];
        mapped.sort((a: any, b: any) => Number(b.reportYear) - Number(a.reportYear));
        this.tierReportYears = mapped;
        this.syncActiveYear();
        this.isTierReportYearsLoading = false;
      },
      (error) => {
        this.isTierReportYearsLoading = false;
        console.log('Error: ', error);
        this.alert = {
          message: `<strong>Failed to load Tier Years</strong><br/>${error.error?.error?.message || ''}`,
          alertClass: 'danger',
          fadeOut: true,
        };
      }
    );
  }

  public addTierYear(): void {
    if (!this.selectedTier) { return; }
    this.tierReportYears = [
      ...this.tierReportYears,
      {
        reportId: this.selectedTier.reportId ?? null,
        reportYear: this.currentYear ?? null,
        isVisible: 'Y',
        isNew: true,
      },
    ];
  }

  public saveTierYear(row: any, index: number): void {
    if (!this.selectedTier) { return; }
    const reportId = Number(row.reportId);
    const reportYear = Number(row.reportYear);
    if (!reportId || !reportYear) {
      this.alert = {
        message: 'Report ID and Report Year are required.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }
    if (!this.selectedTier.chartId) {
      this.alert = {
        message: 'Chart ID is required to add a Tier Year.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }
    this.projectService.addTierReportYear(this.selectedTier.chartId, this.selectedTier.id, reportId, reportYear, row.isVisible).subscribe(
      () => {
        row.reportId = reportId;
        row.reportYear = reportYear;
        row.isNew = false;
        this.tierReportYears = [...this.tierReportYears];
        this.refreshTierSlider();
        this.alert = { message: 'Tier Year added.', alertClass: 'success', fadeOut: true };
      },
      (error) => {
        console.log('Error: ', error);
        this.alert = {
          message: `<strong>Add Failed</strong><br/>${error.error?.error?.message || ''}`,
          alertClass: 'danger',
          fadeOut: true,
        };
      }
    );
  }

  public deleteTierYear(row: any, index: number): void {
    if (!this.selectedTier) { return; }
    if (row.isNew) {
      this.tierReportYears.splice(index, 1);
      this.tierReportYears = [...this.tierReportYears];
      return;
    }
    if (!confirm(`Delete tier year for Report ${row.reportId} / ${row.reportYear}?`)) {
      return;
    }
    this.projectService.deleteTierReportYear(row.reportId, this.selectedTier.id, row.reportYear).subscribe(
      () => {
        this.tierReportYears.splice(index, 1);
        this.tierReportYears = [...this.tierReportYears];
        this.alert = { message: 'Tier Year deleted.', alertClass: 'success', fadeOut: true };
      },
      (error) => {
        console.log('Error: ', error);
        this.alert = {
          message: `<strong>Delete Failed</strong><br/>${error.error?.error?.message || ''}`,
          alertClass: 'danger',
          fadeOut: true,
        };
      }
    );
  }

  public isQuestionNested(questionType: string): boolean {
    let isNested = true;
    if (['N1', 'YN', 'LS', 'TX', 'N2', 'N3', 'RD', 'YNX', 'N4'].includes(questionType)) 
      {
        isNested = false;
      }
    return isNested;
  }

  public getQuestionDetails(questionId: number, event: any): void {
    event.target.classList.toggle('rotated')
    const collapsible = document.getElementById(questionId.toString())
    if (collapsible) {
      collapsible.classList.toggle('hidden')
    }
    /// A new endpoint is going to be created to replace the one used from the service below;
    /// when the new endpoint (something like “/projects/:id/serviceItemId/getProjectQuestions”) will be available create a new method inside projectService 
    /// and replace the method below with the new method
    this.projectService.getProjectQuestionDetails(questionId).subscribe(
      (success) => {
        let details = success.data.questionDetails
        let nestedQuestions: Array<any> = details.nestedQuestions;
        // Do the headings array's element have to be displayed as children questions? If yes, uncomment the lines below!
        // let headings: Array<any> = details.headings or nestedQuestions.headings ?????????????????????
        // let combined = nestedQuestions.concat(headings) ????????????????????????????????
        // this.questionDetails= combined; ??????????????????????????????????????????????????
        this.respondedQuestions.forEach(q=>{
          if(q.questionId===questionId) {
            q.questionDetails=nestedQuestions
          }
        })
      },
      (error) => {
        console.log('Error: ', error);
        this.loadingError = error.error.error.message;
      }
    );
  }

  public onSelectQuestion(questionId: number, questionPart: number = 1, questionText: string): void {
    this.selectedParameter.questionId = questionId;
    this.selectedParameter.questionPart = questionPart;
    this.selectedParameter.questionText = questionText;
    this.isQuestionSelectorOpened = false;

    const bottomForm = this.parameterDetailsBottomFormRef?.form;
    if (bottomForm) {
      bottomForm.patchValue({ questionId, questionPart }, { emitEvent: false });
      bottomForm.get('questionId')?.markAsDirty();
    }
  }

  public onQuestionsSectionToggle(): void {
    this.clearInput()
    if (!this.currentYearQuestions.length)
      this.getProjectQuestions(this.currentProject.projectId, this.currentYear, this.serviceItemId);
    this.isQuestionSelectorOpened = !this.isQuestionSelectorOpened;
  }

  public clearInput() {
    this.searchValue = '';
    this.appliedSearchValue = '';
  }

  public searchInput(event: any) {
    this.searchValue = event == null ? '' : event;
  }

  public applyQuestionSearchNow(): void {
    this.appliedSearchValue = this.searchValue;
  }

  updateSeries(event: any): void {
    const data: any = {
      constantValue: event.row.constantValue,
      questionId: event.row.questionId,
      questionPart: event.row.questionPart,
      isMandatory: event.row.isMandatory, 
      parameterType: event.row.parameterType,
  }
    this.projectService.updateSeries(this.selectedParameter.parameterId, data).subscribe(
      (response: any) => {
        if (!response.success) {
          this.alert = {
            message: 'Series update Failed.',
            alertClass: 'danger',
            fadeOut: true,
          };
          return;
        }
        this.alert = {
          message: 'Series updated successfully.',
          alertClass: 'success',
          fadeOut: true,
        };
      },
    );
}

  // ///////////////////////////////////////////// VIEW TYPES (REPORT TYPES) MANAGEMENT //////////////////////////////////////////////////////////////////////////////////////

  public addReportType(): void {
    if (!this.selectedTier || !this.selectedTier.reportDetails) {
      this.alert = {
        message: 'No report selected.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }

    // Create new report type object with default values
    const newReportType = {
      chartType: '',
      chartTypeDupe: '',
      viewName: '',
      displaySequence: this.getNextDisplaySequence(),
      alternativeReportId: undefined,
    };

    // Add to local array first for UI
    if (!this.selectedTier.reportDetails.reportTypes) {
      this.selectedTier.reportDetails.reportTypes = [];
    }
    this.selectedTier.reportDetails.reportTypes.push(newReportType);
    this.selectedTier.reportDetails = Object.assign({}, this.selectedTier.reportDetails);
    this.hasUnsavedViewTypesChanges = true;
  }

  public saveReportType(reportType: any, index: number, showAlerts: boolean = true, onComplete?: (success: boolean) => void): void {
    if (!this.selectedTier || !this.selectedTier.reportDetails) {
      if (showAlerts) {
        this.alert = {
          message: 'No report selected.',
          alertClass: 'danger',
          fadeOut: true,
        };
      }
      if (onComplete) { onComplete(false); }
      return;
    }

    // Determine if it's a new or existing record
    const isNewRecord = !reportType.chartType;

    // Validate required fields
    if (!reportType.chartTypeDupe || !reportType.viewName || reportType.displaySequence === undefined || reportType.displaySequence === null || reportType.displaySequence === '') {
      if (showAlerts) {
        this.alert = {
          message: 'Chart Type, View Name, and Order are required.',
          alertClass: 'danger',
          fadeOut: true,
        };
      }
      if (onComplete) { onComplete(false); }
      return;
    }

    const chartType = isNewRecord ? reportType.chartTypeDupe : reportType.chartType;
    const viewName = reportType.viewName;
    const displaySequence = reportType.displaySequence;

    if (isNewRecord) {
      // POST - Add new report type
      this.projectService.addReportType(
        this.selectedTier.reportId,
        chartType,
        viewName,
        displaySequence,
        reportType.alternativeReportId
      ).subscribe(
        (response: any) => {
          if (!response.success) {
            this.alert = {
              message: 'Failed to add View Type.',
              alertClass: 'danger',
              fadeOut: true,
            };
            // Remove the unsaved record from the list
            this.selectedTier.reportDetails.reportTypes.splice(index, 1);
            this.selectedTier.reportDetails = Object.assign({}, this.selectedTier.reportDetails);
            return;
          }
          reportType.chartType = chartType;
          reportType.chartTypeDupe = chartType;
          if (showAlerts) {
            this.alert = {
              message: 'View Type added successfully.',
              alertClass: 'success',
              fadeOut: true,
            };
          }
          this.selectedTier.reportDetails = Object.assign({}, this.selectedTier.reportDetails);
          if (onComplete) { onComplete(true); }
        },
        (error: any) => {
          this.alert = {
            message: 'Failed to add View Type: ' + (error.error?.error?.message || error.message),
            alertClass: 'danger',
            fadeOut: true,
          };
          // Remove the unsaved record from the list
          this.selectedTier.reportDetails.reportTypes.splice(index, 1);
          this.selectedTier.reportDetails = Object.assign({}, this.selectedTier.reportDetails);
          if (onComplete) { onComplete(false); }
        }
      );
    } else {
      // PATCH - Edit existing report type
      this.projectService.editReportType(
        this.selectedTier.reportId,
        reportType.chartType,
        reportType.chartTypeDupe,
        viewName,
        displaySequence
      ).subscribe(
        (response: any) => {
          if (!response.success) {
            this.alert = {
              message: 'Failed to edit View Type.',
              alertClass: 'danger',
              fadeOut: true,
            };
            return;
          }
          // Update the chartType to reflect the new value
          if (reportType.chartTypeDupe !== reportType.chartType) {
            reportType.chartType = reportType.chartTypeDupe;
          }
          if (showAlerts) {
            this.alert = {
              message: 'View Type updated successfully.',
              alertClass: 'success',
              fadeOut: true,
            };
          }
          this.selectedTier.reportDetails = Object.assign({}, this.selectedTier.reportDetails);
          if (onComplete) { onComplete(true); }
        },
        (error: any) => {
          this.alert = {
            message: 'Failed to edit View Type: ' + (error.error?.error?.message || error.message),
            alertClass: 'danger',
            fadeOut: true,
          };
          if (onComplete) { onComplete(false); }
        }
      );
    }
  }

  public saveAllReportTypes(): void {
    if (!this.selectedTier || !this.selectedTier.reportDetails || !this.selectedTier.reportDetails.reportTypes) {
      this.alert = {
        message: 'No report selected.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }

    if (this.selectedTier.reportDetails.reportTypes.length === 0) {
      this.alert = {
        message: 'No View Types to save.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }

    if (this.hasDuplicateDisplaySequences()) {
      this.alert = {
        message: 'Order must be unique for each View Type.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }

    let pending = this.selectedTier.reportDetails.reportTypes.length;
    let failed = false;

    this.selectedTier.reportDetails.reportTypes.forEach((reportType: any, index: number) => {
      this.saveReportType(reportType, index, true, (success: boolean) => {
        if (!success) {
          failed = true;
        }
        pending -= 1;
        if (pending === 0) {
          this.hasUnsavedViewTypesChanges = failed;
        }
      });
    });
  }

  public onReportTypeFieldChange(reportType: any, index: number): void {
    this.hasUnsavedViewTypesChanges = true;
  }

  public deleteReportType(reportType: any, index: number): void {
    if (!this.selectedTier || !this.selectedTier.reportDetails) {
      this.alert = {
        message: 'No report selected.',
        alertClass: 'danger',
        fadeOut: true,
      };
      return;
    }

    if (!reportType.chartType) {
      // Remove unsaved record from the list
      this.selectedTier.reportDetails.reportTypes.splice(index, 1);
      this.selectedTier.reportDetails = Object.assign({}, this.selectedTier.reportDetails);
      this.hasUnsavedViewTypesChanges = true;
      return;
    }

    // Confirm deletion
    if (!confirm(`Are you sure you want to delete the View Type "${reportType.viewName}" (${reportType.chartType})?`)) {
      return;
    }

    this.projectService.deleteReportType(
      this.selectedTier.reportId,
      reportType.chartType
    ).subscribe(
      (response: any) => {
        if (!response.success) {
          this.alert = {
            message: 'Failed to delete View Type.',
            alertClass: 'danger',
            fadeOut: true,
          };
          return;
        }
        // Remove from local array
        this.selectedTier.reportDetails.reportTypes.splice(index, 1);
        this.alert = {
          message: 'View Type deleted successfully.',
          alertClass: 'success',
          fadeOut: true,
        };
        this.selectedTier.reportDetails = Object.assign({}, this.selectedTier.reportDetails);
        this.hasUnsavedViewTypesChanges = false;
      },
      (error: any) => {
        this.alert = {
          message: 'Failed to delete View Type: ' + (error.error?.error?.message || error.message),
          alertClass: 'danger',
          fadeOut: true,
        };
      }
    );
  }

  private getNextDisplaySequence(): number {
    if (!this.selectedTier.reportDetails.reportTypes || this.selectedTier.reportDetails.reportTypes.length === 0) {
      return 1;
    }
    const maxSequence = Math.max(...this.selectedTier.reportDetails.reportTypes.map((rt: any) => rt.displaySequence || 0));
    return maxSequence + 1;
  }

  public getDisplaySequenceOptions(): number[] {
    if (!this.selectedTier || !this.selectedTier.reportDetails || !this.selectedTier.reportDetails.reportTypes) {
      return [];
    }

    const reportTypes = this.selectedTier.reportDetails.reportTypes;
    if (reportTypes.length === 0) {
      return [];
    }

    const maxExisting = Math.max(
      ...reportTypes.map((rt: any) => Number(rt.displaySequence) || 0),
      reportTypes.length
    );

    return Array.from({ length: maxExisting }, (_, idx) => idx + 1);
  }

  public onDisplaySequenceChange(changedIndex: number, newOrder: number): void {
    const reportTypes = this.selectedTier.reportDetails.reportTypes;
    const oldOrder = Number(reportTypes[changedIndex].displaySequence);

    if (oldOrder === newOrder) { return; }

    // Shift all items between the old and new positions
    reportTypes.forEach((rt: any, idx: number) => {
      if (idx === changedIndex) { return; }
      const seq = Number(rt.displaySequence);
      if (oldOrder < newOrder) {
        // Moving down: items between old+1 and new shift up by 1
        if (seq > oldOrder && seq <= newOrder) {
          rt.displaySequence = seq - 1;
        }
      } else {
        // Moving up: items between new and old-1 shift down by 1
        if (seq >= newOrder && seq < oldOrder) {
          rt.displaySequence = seq + 1;
        }
      }
    });

    reportTypes[changedIndex].displaySequence = newOrder;

    // Capture row positions before sort (FLIP: First)
    const beforePositions = new Map<string, number>();
    document.querySelectorAll('[data-charttype]').forEach((el) => {
      const key = (el as HTMLElement).dataset['charttype'];
      if (key) {
        beforePositions.set(key, el.getBoundingClientRect().top);
      }
    });

    // Sort (FLIP: Last)
    reportTypes.sort((a: any, b: any) => Number(a.displaySequence) - Number(b.displaySequence));
    this.selectedTier.reportDetails = Object.assign({}, this.selectedTier.reportDetails);

    // Animate from old to new positions (FLIP: Invert + Play)
    requestAnimationFrame(() => {
      document.querySelectorAll('[data-charttype]').forEach((el) => {
        const key = (el as HTMLElement).dataset['charttype'];
        const before = key ? beforePositions.get(key) : undefined;
        if (before === undefined) { return; }
        const after = el.getBoundingClientRect().top;
        const dy = before - after;
        if (dy === 0) { return; }
        const htmlEl = el as HTMLElement;
        htmlEl.style.transition = 'none';
        htmlEl.style.transform = `translateY(${dy}px)`;
        requestAnimationFrame(() => {
          htmlEl.style.transition = 'transform 300ms ease';
          htmlEl.style.transform = '';
        });
      });
    });
    this.hasUnsavedViewTypesChanges = true;
  }

  private hasDuplicateDisplaySequences(): boolean {
    if (!this.selectedTier || !this.selectedTier.reportDetails || !this.selectedTier.reportDetails.reportTypes) {
      return false;
    }

    const used = new Set<number>();
    for (const rt of this.selectedTier.reportDetails.reportTypes) {
      const order = Number(rt.displaySequence);
      if (!order) {
        continue;
      }

      if (used.has(order)) {
        return true;
      }

      used.add(order);
    }

    return false;
  }
}
